
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.505 14.248L14.41 12l-3.904-2.248v4.496z","fill":"#fff"}}),_c('path',{attrs:{"d":"M12 0C5.374 0 0 5.374 0 12s5.374 12 12 12 12-5.374 12-12S18.626 0 12 0zm7.498 12.012s0 2.434-.309 3.607a1.88 1.88 0 01-1.321 1.322c-1.174.309-5.868.309-5.868.309s-4.682 0-5.868-.321a1.88 1.88 0 01-1.321-1.322C4.5 14.446 4.5 12 4.5 12s0-2.433.31-3.607a1.917 1.917 0 011.321-1.334C7.306 6.75 12 6.75 12 6.75s4.694 0 5.868.321a1.88 1.88 0 011.322 1.322c.32 1.174.308 3.62.308 3.62z","fill":"#fff"}})])
          )
        }
      }
    